import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

import { LessonFamily } from './lesson-family.model';
import { DateUtils } from 'ng-jhipster';
import { AbstractEntityService } from '../../shared/service/abstract-entity.service';
import { Reservation } from '../reservation';

@Injectable()
export class LessonFamilyService extends AbstractEntityService {

    protected resourceUrl = 'api/lesson-families';
    private resourceSearchUrl = 'api/_search/lesson-families';
    protected resourceCountUrl = 'api/_search/count/lesson-families';

    constructor(protected http: HttpClient, private dateUtils: DateUtils) { super(http); }

    create(lessonFamily: LessonFamily): Observable<LessonFamily> {
        let copy: LessonFamily = Object.assign({}, lessonFamily);
        copy.startDate = this.dateUtils.toDate(lessonFamily.startDate);
        copy.endDate = this.dateUtils.toDate(lessonFamily.endDate);
        copy.free = copy.free ? copy.free : false;
        return this.http.post<LessonFamily>(this.resourceUrl, copy).map((res: LessonFamily) => {
            return res;
        });
    }

    update(lessonFamily: LessonFamily): Observable<LessonFamily> {
        let copy: LessonFamily = Object.assign({}, lessonFamily);

        return this.http.put<LessonFamily>(this.resourceUrl, copy).map((res: LessonFamily) => {
            return res;
        });
    }

    find(id: number): Observable<LessonFamily> {
        return this.http.get<LessonFamily>(`${this.resourceUrl}/${id}`).map((res: LessonFamily) => {
            let jsonResponse = res;
            jsonResponse.startDate = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.startDate);
            jsonResponse.endDate = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.endDate);
            return jsonResponse;
        });
    }

    query(req?: any): Observable<HttpResponse<LessonFamily[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<LessonFamily[]>>(this.resourceUrl, options)
            .map((res: HttpResponse<LessonFamily[]>) => this.convertResponse(res))
            ;
    }

    search(req?: any): Observable<HttpResponse<LessonFamily[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<LessonFamily[]>>(this.resourceSearchUrl, options)
            .map((res: HttpResponse<LessonFamily[]>) => this.convertResponse(res))
            ;
    }


    private convertResponse(res: HttpResponse<LessonFamily[]>): any {
        let jsonResponse = res.body;
        for (let i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].startDate = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].startDate);
            jsonResponse[i].endDate = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].endDate);
        }
        return res.clone({body: jsonResponse});
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/lesson-family/lesson-family.service.ts